import { uniqueId } from 'lodash';

export const EXAMINEE_TYPES_FILTERS = {
  writing: 'true',
  noWriting: 'false',
};

export const ASSIGN_FILTERS = {
  assigned: 'true',
  notAssigned: 'false',
};


export const DEFAULT_PARAMS = {
  skip: 0,
  limit: 30,
};

export const pageSizeOptions = [20, 30, 50];

export const toRadioList = (labels, filters) =>{
  let list = [];
  list.push({
    key: uniqueId(),
    label: 'All',
    value: '',
  });

  Object.keys(labels).forEach(key => {
    list.push({
      key:`key-${labels[key]}`,
      label: labels[key],
      value: filters ? filters[key] : key,
    })
  });
  return list;
};